import moment from 'moment';

/**
 * Check if a cart item's date range is outside the user's stay period
 * @param {Object} cartItem - Cart item with start_time and end_time
 * @param {Object} user - User object with arrival_date and departure_date
 * @param {Object} customer - Customer object with arrival_date and departure_date
 * @returns {boolean} True if the activity is outside the stay period
 */
export const checkOutsideStayPeriod = (cartItem, user, customer) => {
    if (!cartItem?.start_time || !cartItem?.end_time) {
        return false;
    }

    const isGuestUser = user?.id === customer?.id;
    const relevantUser = isGuestUser ? user : customer;

    if (!relevantUser?.arrival_date || !relevantUser?.departure_date) {
        return false;
    }

    const startDate = cartItem.start_time;
    const endDate = cartItem.end_time;

    const isStartOutside = !moment(startDate).isBetween(
        relevantUser.arrival_date,
        relevantUser.departure_date,
        'day',
        '[]'
    );

    const isEndOutside = !moment(endDate).isBetween(
        relevantUser.arrival_date,
        relevantUser.departure_date,
        'day',
        '[]'
    );

    return isStartOutside || isEndOutside;
};

/**
 * Find all bookings that overlap with a cart item's time range
 * @param {Object} cartItem - Cart item with start_time and end_time
 * @param {Array} bookings - Array of existing bookings
 * @returns {Array} Array of overlapping activities with cart item and booking info
 */
export const calculateOverlappingActivities = (cartItem, bookings = []) => {
    if (!cartItem?.start_time || !cartItem?.end_time || !bookings || bookings.length === 0) {
        return [];
    }

    const overlaps = [];
    const cartItemStart = moment.utc(cartItem.start_time);
    const cartItemEnd = moment.utc(cartItem.end_time);

    bookings.forEach(booking => {
        const bookingStart = moment.utc(booking.activity_start);
        const bookingEnd = moment.utc(booking.activity_end);

        // Check for any time overlap including touching boundaries
        const hasOverlap =
            (cartItemStart.isSameOrAfter(bookingStart) && cartItemStart.isBefore(bookingEnd)) ||
            (cartItemEnd.isAfter(bookingStart) && cartItemEnd.isSameOrBefore(bookingEnd)) ||
            (cartItemStart.isSameOrBefore(bookingStart) && cartItemEnd.isSameOrAfter(bookingEnd)) ||
            cartItemStart.isSame(bookingEnd) ||
            cartItemEnd.isSame(bookingStart);

        if (hasOverlap) {
            overlaps.push({
                cartItem,
                booking
            });
        }
    });

    return overlaps;
};
